import { SvgIcon, SvgIconProps } from '@mui/material';

export const FilterIcon = ({ color, fontSize }: SvgIconProps) => {
  return (
    <SvgIcon color={color} fontSize={fontSize}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33213 6.56055C6.95709 6.07865 6.59161 5.60911 6.25018 5.17055C5.74018 4.51055 6.21018 3.56055 7.04018 3.56055H20.9502C21.7902 3.56055 22.2602 4.51055 21.7502 5.17055C19.4302 8.15055 16.0002 12.5605 16.0002 12.5605V17.5605C16.0002 18.6605 15.1002 19.5605 14.0002 19.5605C12.9002 19.5605 12.0002 18.6605 12.0002 17.5605V15.511C12.3832 15.0185 15.5356 10.9655 17.7116 8.17055C18.2216 7.51055 17.7516 6.56055 16.9116 6.56055H7.33213Z"
        fill={color}
      />
      <path
        d="M3.18515 8.4693C5.21515 11.0768 8.2164 14.9355 8.2164 14.9355V19.3105C8.2164 20.273 9.0039 21.0605 9.9664 21.0605C10.9289 21.0605 11.7164 20.273 11.7164 19.3105V14.9355C11.7164 14.9355 14.7177 11.0768 16.7477 8.4693C17.1939 7.8918 16.7827 7.06055 16.0477 7.06055H3.8764C3.15015 7.06055 2.7389 7.8918 3.18515 8.4693Z"
        fill={color}
      />
    </SvgIcon>
  );
};
